import * as React from "react";
import styled from "../../../styled/index";
import darken from "polished/lib/color/darken";
import ReactTooltip from "react-tooltip";
const SideNavLinkComponent = styled("a") `

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 42px;
  border-radius: 3px;
  
  font-size: 18px;
  background: ${({ active, theme }) => active ? theme.colors.primary : darken(0.1, theme.side_nav.background_color)};
  color: ${({ active, theme }) => active ? theme.colors.primary_text : theme.side_nav.text_color};
  
  &:hover {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary_text};
  }
  
`;
export const SideNavLink = (props) => (React.createElement(SideNavLinkComponent, { id: props.id, "data-tip": props.tip, active: props.active, onClick: props.onClick },
    props.icon,
    React.createElement(ReactTooltip, { place: "right", effect: "solid", multiline: false })));
//# sourceMappingURL=link.js.map